"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_1 = __importDefault(require("@emotion/styled"));

var react_1 = __importDefault(require("react"));

var Close_1 = __importDefault(require("./svg/Close"));

var _1 = require("./");

var hasComponent = function hasComponent(children, displayNames) {
  var result = react_1.default.Children.map(children, function (child) {
    var _a, _b;

    if (displayNames.indexOf((_b = (_a = child) === null || _a === void 0 ? void 0 : _a.type) === null || _b === void 0 ? void 0 : _b.displayName) !== -1) {
      return true;
    }

    return false;
  });
  return result.some(function (x) {
    return x;
  });
};

var ModalContainer = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: fixed; /* Stay in place */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  overflow: auto;\n  z-index: 900;\n"], ["\n  position: fixed; /* Stay in place */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  overflow: auto;\n  z-index: 900;\n"])));
var ModalBox = styled_1.default.section(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: fixed;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #fefefe;\n  z-index: 9999999999;\n  display: flex;\n  flex-direction: column;\n  ", "\n\n  @media (min-width: 768px) {\n    & {\n      position: relative;\n      width: ", ";\n      max-width: 90%;\n      top: 0;\n      border-radius: 4px;\n      box-shadow: 1px 1px 5px rgba(157, 157, 157, 0.4);\n    }\n  }\n\n  & > article {\n    padding-top: ", "px;\n    padding-right: ", "px;\n    padding-bottom: ", "px;\n    padding-left: ", "px;\n  }\n"], ["\n  position: fixed;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #fefefe;\n  z-index: 9999999999;\n  display: flex;\n  flex-direction: column;\n  ", "\n\n  @media (min-width: 768px) {\n    & {\n      position: relative;\n      width: ", ";\n      max-width: 90%;\n      top: 0;\n      border-radius: 4px;\n      box-shadow: 1px 1px 5px rgba(157, 157, 157, 0.4);\n    }\n  }\n\n  & > article {\n    padding-top: ", "px;\n    padding-right: ", "px;\n    padding-bottom: ", "px;\n    padding-left: ", "px;\n  }\n"])), function (_a) {
  var fixed = _a.fixed;
  return fixed ? 'max-height: 90vh; overflow: hidden;' : '';
}, function (_a) {
  var width = _a.width;
  return width || '500px';
}, function (_a) {
  var theme = _a.theme,
      children = _a.children;

  var _b, _c, _d, _e, _f, _g;

  return hasComponent(children, ['ModalHeader', 'Styled(header)']) ? (_d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.card) === null || _c === void 0 ? void 0 : _c.paddingInner, _d !== null && _d !== void 0 ? _d : _1.defaultTheme.card.paddingInner) : (_g = (_f = (_e = theme) === null || _e === void 0 ? void 0 : _e.card) === null || _f === void 0 ? void 0 : _f.paddingTop, _g !== null && _g !== void 0 ? _g : _1.defaultTheme.card.paddingTop);
}, function (_a) {
  var theme = _a.theme;

  var _b, _c, _d;

  return _d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.card) === null || _c === void 0 ? void 0 : _c.paddingHorizontal, _d !== null && _d !== void 0 ? _d : _1.defaultTheme.card.paddingHorizontal;
}, function (_a) {
  var theme = _a.theme,
      children = _a.children;

  var _b, _c, _d, _e, _f, _g;

  return hasComponent(children, ['ModalActions', 'Styled(footer)']) ? (_d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.card) === null || _c === void 0 ? void 0 : _c.paddingInner, _d !== null && _d !== void 0 ? _d : _1.defaultTheme.card.paddingInner) : (_g = (_f = (_e = theme) === null || _e === void 0 ? void 0 : _e.card) === null || _f === void 0 ? void 0 : _f.paddingBottom, _g !== null && _g !== void 0 ? _g : _1.defaultTheme.card.paddingBottom);
}, function (_a) {
  var theme = _a.theme;

  var _b, _c, _d;

  return _d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.card) === null || _c === void 0 ? void 0 : _c.paddingHorizontal, _d !== null && _d !== void 0 ? _d : _1.defaultTheme.card.paddingHorizontal;
});
var CloseButton = styled_1.default.button(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: #aaa;\n  position: absolute;\n  background: transparent;\n  border: none;\n  top: 0;\n  right: 0;\n  padding: 10px;\n  width: 40px;\n  height: 40px;\n  outline: none;\n  z-index: 1;\n"], ["\n  color: #aaa;\n  position: absolute;\n  background: transparent;\n  border: none;\n  top: 0;\n  right: 0;\n  padding: 10px;\n  width: 40px;\n  height: 40px;\n  outline: none;\n  z-index: 1;\n"])));
exports.ModalBody = styled_1.default.article(templateObject_4 || (templateObject_4 = __makeTemplateObject([""], [""])));
exports.ModalBody.displayName = 'ModalBody';
exports.ModalHeader = styled_1.default.header(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  padding-top: ", "px;\n  padding-right: ", "px;\n  padding-bottom: ", "px;\n  padding-left: ", "px;\n  display: flex;\n  flex-direction: column;\n  font-size: 20px;\n"], ["\n  padding-top: ", "px;\n  padding-right: ", "px;\n  padding-bottom: ", "px;\n  padding-left: ", "px;\n  display: flex;\n  flex-direction: column;\n  font-size: 20px;\n"])), function (_a) {
  var theme = _a.theme;

  var _b, _c, _d;

  return _d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.card) === null || _c === void 0 ? void 0 : _c.paddingTop, _d !== null && _d !== void 0 ? _d : _1.defaultTheme.card.paddingTop;
}, function (_a) {
  var theme = _a.theme;

  var _b, _c, _d;

  return _d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.card) === null || _c === void 0 ? void 0 : _c.paddingHorizontal, _d !== null && _d !== void 0 ? _d : _1.defaultTheme.card.paddingHorizontal;
}, function (_a) {
  var theme = _a.theme;

  var _b, _c, _d;

  return _d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.card) === null || _c === void 0 ? void 0 : _c.paddingInner, _d !== null && _d !== void 0 ? _d : _1.defaultTheme.card.paddingInner;
}, function (_a) {
  var theme = _a.theme;

  var _b, _c, _d;

  return _d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.card) === null || _c === void 0 ? void 0 : _c.paddingHorizontal, _d !== null && _d !== void 0 ? _d : _1.defaultTheme.card.paddingHorizontal;
});
exports.ModalHeader.displayName = 'ModalHeader';
exports.ModalTitle = styled_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject([""], [""])));
exports.ModalActions = styled_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  padding-top: ", "px;\n  padding-right: ", "px;\n  padding-bottom: ", "px;\n  padding-left: ", "px;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n"], ["\n  padding-top: ", "px;\n  padding-right: ", "px;\n  padding-bottom: ", "px;\n  padding-left: ", "px;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n"])), function (_a) {
  var theme = _a.theme;

  var _b, _c, _d;

  return _d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.card) === null || _c === void 0 ? void 0 : _c.paddingInner, _d !== null && _d !== void 0 ? _d : _1.defaultTheme.card.paddingInner;
}, function (_a) {
  var theme = _a.theme;

  var _b, _c, _d;

  return _d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.card) === null || _c === void 0 ? void 0 : _c.paddingHorizontal, _d !== null && _d !== void 0 ? _d : _1.defaultTheme.card.paddingHorizontal;
}, function (_a) {
  var theme = _a.theme;

  var _b, _c, _d;

  return _d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.card) === null || _c === void 0 ? void 0 : _c.paddingBottom, _d !== null && _d !== void 0 ? _d : _1.defaultTheme.card.paddingBottom;
}, function (_a) {
  var theme = _a.theme;

  var _b, _c, _d;

  return _d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.card) === null || _c === void 0 ? void 0 : _c.paddingHorizontal, _d !== null && _d !== void 0 ? _d : _1.defaultTheme.card.paddingHorizontal;
});
exports.ModalActions.displayName = 'ModalActions';
exports.ModalAction = styled_1.default(_1.Button)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  text-transform: uppercase;\n  font-weight: 500;\n  padding: 5px 10px;\n  display: inline-block;\n  cursor: pointer;\n"], ["\n  text-transform: uppercase;\n  font-weight: 500;\n  padding: 5px 10px;\n  display: inline-block;\n  cursor: pointer;\n"])));
var ModalClose = styled_1.default(Close_1.default)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  height: 20px;\n  width: 20px;\n  & path {\n    fill: #aaa;\n  }\n  &:hover,\n  &:focus {\n    color: black;\n    text-decoration: none;\n    cursor: pointer;\n  }\n"], ["\n  height: 20px;\n  width: 20px;\n  & path {\n    fill: #aaa;\n  }\n  &:hover,\n  &:focus {\n    color: black;\n    text-decoration: none;\n    cursor: pointer;\n  }\n"])));

exports.Modal = function (_a) {
  var title = _a.title,
      children = _a.children,
      open = _a.open,
      onClose = _a.onClose,
      width = _a.width,
      fixed = _a.fixed,
      _b = _a.closeLabel,
      closeLabel = _b === void 0 ? 'close' : _b;
  return open ? react_1.default.createElement(ModalContainer, null, react_1.default.createElement(_1.Backdrop, {
    open: open,
    onClose: onClose
  }), react_1.default.createElement(ModalBox, {
    width: width,
    fixed: fixed
  }, react_1.default.createElement(CloseButton, {
    "aria-label": closeLabel,
    onClick: onClose
  }, react_1.default.createElement(ModalClose, null)), title && react_1.default.createElement(exports.ModalHeader, null, react_1.default.createElement(exports.ModalTitle, null, title)), children)) : null;
};

var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;